import React from 'react'
import Paper from '@mui/material/Paper';
import SyncIcon from '@mui/icons-material/Sync';
import DownloadIcon from '@mui/icons-material/Download';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const columns = [
    { id: 'file_name', label: 'File Name' },
    { id: 'added_at', label: 'Upload Date' },
    { id: 'is_mapped', label: 'Is Mapped' },
    { id: 'actions', label: 'Actions'}
];



const MappingDownloadTable = ({downloadMappingData,handleDownloadFile,handleSyncMappedFile}) => {
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer className='TableVirtuoso' sx={{ maxHeight: "100vh" }}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {downloadMappingData?.data?.length > 0 ? downloadMappingData?.data.map((row,i) => {
                        return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                        <TableCell key={column.id} align={column.align}>
                                            {column.format && typeof value === 'number'
                                                ? column.format(value) : 
                                                column.id === 'added_at' ? new Date(row?.added_at).toLocaleDateString("en-us", { year: 'numeric', month: '2-digit', day: '2-digit' })
                                                : column.id === 'is_mapped' ? row?.is_mapped === 1 ? 'Yes' : 'No'
                                                : column.id === 'actions' ? 
                                                <>  
                                                    <IconButton 
                                                        color="inherit" 
                                                        title="Download Mapped File"
                                                        onClick={()=> handleDownloadFile(row.id,row.file_name)}
                                                    >
                                                        <DownloadIcon/>
                                                    </IconButton>
                                                    {row?.is_mapped === 0 && 
                                                            <IconButton 
                                                                color="inherit" 
                                                                title="Map File with Tables"
                                                                onClick={()=> handleSyncMappedFile(row.id)}
                                                            >
                                                                <SyncIcon/>
                                                            </IconButton>
                                                    }
                                                    
                                                </>
                                                : value 
                                            }
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
        {/* {downloadMappingData?.total > 0 ?
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={downloadMappingData?.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage} 
            />
            : <></>
        } */}
    </Paper> 
  )
}


export default MappingDownloadTable